import React, { memo, useCallback, useEffect, useMemo } from 'react'
import { inject, observer } from 'mobx-react'
import DashboardLayout from '../../layouts/DashboardLayout'
import { Helmet } from 'react-helmet/es/Helmet'
import PageTitle from '../../components/PageTitle'
import { Select } from 'antd'
import { BankOutlined } from '@ant-design/icons'
import {
  CompanySelectDropdownStyle,
  CompanySelectWrapper,
  ContactContentWrapper,
  ContactPageHeading,
  TabContainer,
} from './ContactStyled'
import ListDepartmentPage from './ListDepartment'
import EmptyContent from '../../components/EmptyContent'
import contactStore from './contactStore'

const { Option } = Select

const ContactPage = props => {
  const { userStore, authenticationStore, companyStore } = props
  const { companyList } = companyStore
  const { companyCode } = contactStore
  const companySignature = companyList
    .map(item => `${item.code}:${item.name}`)
    .join('|')
  const contactBreadcrumb = useMemo(
    () => <ContactPageHeading>Danh bạ</ContactPageHeading>,
    []
  )

  useEffect(() => {
    if (authenticationStore.currentUser) {
      userStore.setFilter('userListStatus', true)
      userStore.setFilter(
        'companyCode',
        authenticationStore.currentCompanyCode()
      )
      contactStore.companyCode = authenticationStore.currentCompanyCode()
    }
    return () => {
      userStore.clearStore()
    }
  }, [authenticationStore.currentUser])

  const onCompanyChange = useCallback(
    value => {
      contactStore.companyCode = value
      userStore.setFilter('companyCode', value)
      userStore.setFilter('userOfDepartmentListByDepartmentCode', null)
      userStore.setFilter('userOfDepartmentListPageIndex', 0)
      userStore.setFilter('userListPageIndex', 0)
      userStore.clearUserListKeyword()

      if (!value) {
        userStore.clearStore()
        contactStore.companyCode = null
      }
    },
    [userStore]
  )

  const filterCompanyOption = useCallback((input, option) => {
    const optionText = option?.children?.toString() || ''
    return optionText.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }, [])

  const companyOptions = useMemo(
    () =>
      companyList.map(item => (
        <Option key={item.code} value={item.code}>
          {item.name}
        </Option>
      )),
    [companyList, companySignature]
  )

  return (
    <DashboardLayout>
      <Helmet>
        <title>Danh bạ</title>
      </Helmet>
      <CompanySelectDropdownStyle />
      <PageTitle
        location={props.location}
        title={'Danh bạ'}
        hiddenGoBack
        customBreadcrumb={contactBreadcrumb}>
        <CompanySelectWrapper>
          <BankOutlined className="company-prefix-icon" />
          <Select
            allowClear
            showSearch
            dropdownClassName="company-select-dropdown"
            filterOption={filterCompanyOption}
            value={companyCode}
            onChange={onCompanyChange}
            notFoundContent={<EmptyContent />}
            placeholder={'-- Chọn công ty --'}>
            {companyOptions}
          </Select>
        </CompanySelectWrapper>
      </PageTitle>
      <ContactContentWrapper>
        <TabContainer>
          <ListDepartmentPage />
        </TabContainer>
      </ContactContentWrapper>
    </DashboardLayout>
  )
}

ContactPage.propTypes = {}

export default memo(
  inject(
    'userStore',
    'authenticationStore',
    'companyStore'
  )(observer(ContactPage))
)
